import { POST } from "../../index";

export const selectKeyAuthorizeList = (param) => POST("/v1/keyAuthorize/selectKeyAuthorizeList", param);
export const insertKeyAuthorize = (param) => POST("/v1/keyAuthorize/insertAuthorize", param);
export const ICAuthorize = (param) => POST("/v1/keyAuthorize/insertKeyAuthorize", param);
export const clearICAuthorize = (param) => POST("/v1/keyAuthorize/clearAuthorize", param);
export const deleteICAuthorize = (param) => POST("/v1/keyAuthorize/deleteKeyAuthorize", param);
export const selectTerminalAuthorize = (param) => POST("/v1/keyAuthorize/selectTerminalAuthorize", param);
export const refreshIC = (param) => POST("/v1/keyAuthorize/refresh", param);